export default __webpack_public_path__ + "static/media/ic_wcro_16.0e03ec7d.svg";